import { InjectionToken } from '@angular/core';
export const WebAngularSharedUtilErrorHandlingConfig: InjectionToken<boolean> = new InjectionToken<boolean>(
  'WebAngularSharedUtilErrorHandlingConfig'
);

export interface WebAngularSharedUtilErrorHandlingOptions {
  doNotRedirectOnErrorGuard?: boolean;
  handleAllFailActions?: boolean;
  showNotificationOnRouteTransition?: boolean;
  errorRedirectRoute?: string;
}
